import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { autoComplete } from "../../services/pappers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import autoCompleteZipCode from "../../services/zipCodes";
import { emailValidationSchema } from "../../validationSchemas/utilisateur.validation";

const ForgotPasswordForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const { email } = props;
  const [listDenominations, setListDenominations] = useState([]);
  const [listZipCodes, setListZipCodes] = useState([]);
  const [allForm, setAllForm] = useState({
    email
  });

  return (
    <Formik
      initialValues={{
        ...allForm
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Adresse E-mail nécessaire";
        } else if (!EmailValidator.validate(values.email)) {
          errors.email = "Adresse E-mail invalide";
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={emailValidationSchema}
    >
      {props => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        return (
          <form name="forgotPassword" onSubmit={handleSubmit}>
            <h2>Réinitialiser votre mot de passe</h2>
            <Row>
              <Col xs={12}>
                <label htmlFor="email" className="form-label">
                  Merci de spécifier l'adresse E-Mail associée à votre compte
                </label>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.email && touched.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Continuer
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
              <Col xs={12}>
                <hr />
                <span>
                  <a
                    className="callToActionLink"
                    onClick={() => navigate("/login")}
                  >
                    Retour
                  </a>{" "}
                </span>
              </Col>
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default ForgotPasswordForm;
